import { render, staticRenderFns } from "./slip.vue?vue&type=template&id=36878c64&"
import script from "./slip.vue?vue&type=script&lang=js&"
export * from "./slip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiBetbuilderHeader: require('/var/web/bet777.es/themes/dark/ui/Betbuilder/Header.vue').default,BetbuilderCalc: require('/var/web/bet777.es/components/betbuilder/calc.vue').default,UiBetbuilderSummary: require('/var/web/bet777.es/themes/dark/ui/Betbuilder/Summary.vue').default,UiBetbuilderContainer: require('/var/web/bet777.es/themes/dark/ui/Betbuilder/Container.vue').default})
